
import { Component, Prop, Vue } from 'vue-property-decorator';
import { eRulesDialogContentStatus } from '@/interface/backup-tactics';
import { getWeeks } from '@/utils/common';
import { log } from 'console';
@Component
export default class SpecialTime extends Vue {
  @Prop({ default: 1 }) index!: number;
  @Prop() info!: any;
  @Prop({ default: eRulesDialogContentStatus.INFO }) status!: string;
  @Prop() lastIndex!: boolean;
  circles: Array<any> = getWeeks();
  isInfo = true;

  changeTime(e: string, key: string, time: { start: number; end: number; startStr?: string; endStr?: string; [key: string]: number | string | undefined }) {
    const str = e.split(':');
    const hourstr = str[0];
    const minutestr = str[1];

    const value = Number(hourstr) * 60 * 60 + Number(minutestr) * 60;
    time[key] = value;
  }
  formatterHour(time: number) {
    if (time === null || time === undefined) return '';
    const hour = parseInt((time / 60 / 60).toString())
      .toString()
      .padStart(2, '0');
    const minute = ((time / 60) % 60).toString().padStart(2, '0');
    return `${hour}:${minute}`;
  }
  mounted() {
    this.isInfo = this.status === eRulesDialogContentStatus.INFO;

    this.info.backup_periods.forEach((item: any) => {
      this.$set(item, 'startStr', `${this.formatterHour(item.start)}`);
      this.$set(item, 'endStr', `${this.formatterHour(item.end)}`);
    });
  }
  /**
   * 校验填入价格 只能是数字
   */
  changePrice(e: string, key: string, type: string) {
    if (!e) {
      // console.log(e, '23233');

      this.info.backup_num[key][type] = e;
    } else {
      const reg = RegExp(/^\d*$/);
      if (reg.test(e)) {
        // console.log(this.ruleInfo, '2');
        this.info.backup_num[key][type] = Number(e);
      }
    }
  }
  addSpecialTime() {
    this.$emit('addSpecialTime');
  }
  delSpecialTime() {
    this.$emit('delSpecialTime', this.index);
  }

  addTime() {
    this.info.backup_periods.push({ startTime: '', endTime: '' });
  }
  minusTime(index: number) {
    this.info.backup_periods.splice(index, 1);
  }
}
